import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Youtube, Facebook, Instagram, Music2 } from 'lucide-react';
import { Button, WHATSAPP_LINK } from './ui';
const legalLinks = [{
  label: 'Termeni și Condiții',
  href: 'https://nlpacademyromania.ro/termeni-si-conditii'
}, {
  label: 'Politică de Confidențialitate',
  href: 'https://nlpacademyromania.ro/politica-de-confidentialitate'
}, {
  label: 'Politică de Cookies',
  href: 'https://nlpacademyromania.ro/politica-cookies'
}];
const socialLinks = [{
  label: 'WhatsApp',
  href: WHATSAPP_LINK,
  icon: MessageCircle
}, {
  label: 'YouTube',
  href: 'https://www.youtube.com/@explore2successnlp',
  icon: Youtube
}, {
  label: 'Facebook',
  href: 'https://www.facebook.com/explore2success',
  icon: Facebook
}, {
  label: 'Instagram',
  href: 'https://www.instagram.com/marius_cernea_nlp_academy/',
  icon: Instagram
}, {
  label: 'TikTok',
  href: 'https://www.tiktok.com/@explore2success',
  icon: Music2
}];
export const Footer = () => {
  return <footer className="bg-[#060810] pt-24 pb-8 border-t border-gold/20" data-id="element-39">
      <div className="container mx-auto px-6" data-id="element-40">
        {/* Footer CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto mb-24" data-id="element-41">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-42">
            Ești gata să faci primul pas?
          </h2>
          <p className="font-sans text-textSub text-xl mb-10" data-id="element-43">
            Locurile la NLP Practitioner sunt limitate. Dacă simți că e momentul
            tău, nu mai aștepta să fie mai bine. Momentul e acum.
          </p>
          <Button data-id="element-44">Scrie-mi pe WhatsApp pentru detalii!</Button>
        </motion.div>
        <div className="w-full h-px bg-gold/10 mb-12" data-id="element-45" />
        {/* Columns */}
        <div className="grid gap-12 lg:grid-cols-4 md:grid-cols-2" data-id="element-46">
          {/* Contact / Company */}
          <div data-id="element-47">
            <h3 className="font-display text-xs font-bold tracking-widest uppercase text-gold mb-6" data-id="element-48">
              Contact
            </h3>
            <div className="space-y-3 font-sans text-sm text-textSub leading-relaxed" data-id="element-49">
              <p className="text-textLight font-semibold" data-id="element-50">NLP ACADEMY S.R.L.</p>
              <p data-id="element-51">Cod Unic de Înregistrare: 41276675</p>
              <p data-id="element-52">Nr. Înmatriculare: J2019001645057</p>
              <p data-id="element-53">EUID: ROONRC.J2019001645057</p>
              <p data-id="element-54">Data înființării: 18-06-2019</p>
              <p data-id="element-55">Administrator: Cernea Florin Marius</p>
              <p data-id="element-56">
                Telefon:{' '}
                <a href="tel:+40756617959" className="hover:text-gold transition-colors" data-id="element-57">
                  +40 756 617 959
                </a>
              </p>
              <p data-id="element-58">
                Email:{' '}
                <a href="mailto:cermar2002@gmail.com" className="hover:text-gold transition-colors" data-id="element-59">
                  cermar2002@gmail.com
                </a>
              </p>
            </div>
          </div>
          {/* Legal */}
          <div data-id="element-60">
            <h3 className="font-display text-xs font-bold tracking-widest uppercase text-gold mb-6" data-id="element-61">
              Legal
            </h3>
            <ul className="space-y-4 font-sans text-sm text-textSub" data-id="element-62">
              {legalLinks.map(link => <li key={link.href} data-id="element-63">
                  <a href={link.href} className="hover:text-gold transition-colors" data-id="element-64">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
          {/* Social */}
          <div data-id="element-65">
            <h3 className="font-display text-xs font-bold tracking-widest uppercase text-gold mb-6" data-id="element-66">
              Social Media
            </h3>
            <ul className="space-y-4 font-sans text-sm text-textSub" data-id="element-67">
              {socialLinks.map(link => <li key={link.label} data-id="element-68">
                  <a href={link.href} className="flex items-center gap-3 hover:text-gold transition-colors group" data-id="element-69">
                    <link.icon className="w-4 h-4 text-gold/70 group-hover:text-gold transition-colors" data-id="element-70" />
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
          {/* ANPC */}
          <div data-id="element-71">
            <h3 className="font-display text-xs font-bold tracking-widest uppercase text-gold mb-6" data-id="element-72">
              ANPC
            </h3>
            <div className="space-y-4" data-id="element-73">
              <a href="https://anpc.ro/ce-este-sal/" className="block bg-white p-1.5 rounded-md max-w-[230px]" data-id="element-74">
                <img src="https://cdn.magicpatterns.com/uploads/druLpgsRg5XMAnHEU38dLa/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="w-full h-auto" data-id="element-75" />
              </a>
              <a href="https://ec.europa.eu/consumers/odr" className="block bg-white p-1.5 rounded-md max-w-[230px]" data-id="element-76">
                <img src="https://cdn.magicpatterns.com/uploads/4QYMAhXCMjCNikfQvDwiWA/SAL.jpg" alt="Soluționarea Online a Litigiilor" className="w-full h-auto" data-id="element-77" />
              </a>
            </div>
          </div>
        </div>
        <div className="w-full h-px bg-gold/10 my-10" data-id="element-78" />
        {/* Copyright */}
        <p className="text-center font-sans text-sm text-textSub" data-id="element-79">
          © {new Date().getFullYear()}{' '}
          <span className="text-textLight font-semibold" data-id="element-80">
            NLP ACADEMY S.R.L.
          </span>{' '}
          Toate drepturile rezervate.
        </p>
      </div>
    </footer>;
};